<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2a"><a id="page_vi"><span class="bold">List of Maps</span></a></h2><a id="page_vi">
<p class="list">A map from Blaxland’s <em class="italic">Destination Dunkirk</em>, illustrating the BEF withdrawal to the coast</p>
<p class="list">A sketch map showing the position of Gort’s Headquarters and the Post Office at La Panne</p>
<p class="list">Three maps from Hans-Adolf Jacobsen’s <em class="italic">Dünkirchen</em> depicting the contracting perimeter</p>
<p class="list">A sketch map of the Nieuport Bridges from the 13/Field Survey Unit War Diary</p>
<p class="list">A map from the 7/Field Regiment War diary depicting the deployment of BEF and French divisions between La Panne and Nieuport</p>
<p class="list">A map drawn by Second Lieutenant Robin Medley illustrating the two positions occupied by his platoon at Oost-Dunkerque</p>
<p class="list">A map from the DCLI War Diary showing the positions of the three infantry brigades of the 4<sup class="sup">th</sup> Division</p>
<p class="list">A map from <em class="italic">Dunkirk</em> by Robert Jackson showing the Dunkerque Perimeter on 30 May, depicting the British, French and German forces</p>
<p class="list">A map illustrating the positions occupied by the 1<sup class="sup">st</sup> Battalion Duke of Wellington’s Regiment</p>
<p class="list">A map from <em class="italic">Dunkirk</em> by Robert Jackson illustrating the reduced perimeter after the II Corps sector had been abandoned</p>
<p class="list">A map from the <em class="italic">History of the Loyal North Lancashire Regiment</em></p>
<p class="list">A map of the Dunkerque harbour area, showing Bastion 32 and the Royal Naval dugout</p>
<p class="list">A map of Nieuwpoort as it is today</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_Maps.vue?18a3b75b